export type SearchParams = {
  page?: string;
  pageSize?: string;
  q: string;
  sortBy?: string;
  categoryId?: string;
  filterByEquipment?: string;
  model?: string;
  serialNumber?: string;
  facet?: string | string[];
  scrollToProduct?: string;
  searchType?: string;
  isNerEnabled?: string;
  responseFilter?: string;
  source?: string;
  edgePartNumber?: string;
  attachmentPartNumber?: string;
  productFamilyName?: string;
  offset?: string | number;
};

//TODO: add the prefix for each view filters, and omit the old ones from the type SearchParams
export type FederatedSearchParams = Omit<
  SearchParams,
  'source' | 'page' | 'facet' | 'sortBy'
> & {
  d_facet?: string | string[];
  p_facet?: string | string[];
  p_sortBy?: string;
  d_sortBy?: string;
  p_page?: string;
  d_page?: string;
  d_query?: string;
};

export enum PageParamType {
  PAGE = 'page',
  PARTS_PAGE = 'p_page',
  DIAGRAM_PAGE = 'd_page'
}

export type productSearchParams = {
  responseFilter?: string;
  storeIdentifier: string;
  q?: string;
  isNerEnabled?: string;
  categoryId?: string;
  locale?: string;
  sortBy?: string;
  offset?: string | number;
  pageSize?: string;
  facet?: string | string[];
  model?: string;
  serialNumber?: string;
  searchType?: string;
} & FederatedSearchParams;
